export default __webpack_public_path__ + "static/media/ck.86db2678.svg";